export const GET_HEALTH = 'GET_HEALTH';
export const LOADING_HEALTH = 'LOADING_HEALTH';
export const SAVE_LOADER_HEALTH = 'SAVE_LOADER_HEALTH'